const Details = ({ details }) => {
  return (
    <table>
      {Object.keys(details).map((key, index) => (
        <tr className="font-pop text-xs text-textBlack" key={index}>
          <td className="pr-8 font-bold">{key}:-</td>
          <td className="font-normal">{details[key]}</td>
        </tr>
      ))}
    </table>
  );
};

export default Details;
